import { ref } from "vue";

export function getStatusByStatitics(latencia: string, snrv: string, snrh: string, rxh: string, rxv: string) {

    let statusByStatitics = 'DOWN';

    if (snrv && snrh && rxh && rxv) {
        if (latencia === 'OK' && snrv === 'OK' && snrh === 'OK' && rxh === 'OK' && rxv === 'OK') statusByStatitics = 'OK';
        if (latencia === 'ALERT' || snrv === 'ALERT' || snrh === 'ALERT' || rxh === 'ALERT' || rxv === 'ALERT') statusByStatitics = 'ALERT';
        if (latencia === 'ALARM' || snrv === 'ALARM' || snrh === 'ALARM' || rxh === 'ALARM' || rxv === 'ALARM') statusByStatitics = 'ALARM';
        if (latencia === 'DOWN') statusByStatitics = 'DOWN';
    }
    else {
        statusByStatitics = latencia;
    }

    return statusByStatitics;
}


export function getStatusByLatency(latency: number) {
    let statusxlatency = 'DOWNdefault';

    if (latency > 0 && latency <= 100) statusxlatency = 'OK';
    if (latency > 100 && latency <= 500) statusxlatency = 'ALERT';
    if (latency > 500) statusxlatency = 'ALARM';
    if (latency == -1) statusxlatency = 'DOWN';

    return statusxlatency
}

export function getStatusBySNR(snr: number) {
    let peso = 'DOWNdefault';

    if (snr > 20) peso = 'OK';
    if (snr <= 20 && snr >= 16) peso = 'ALERT';
    if (snr < 16) peso = 'ALARM';

    return peso
}

export function getStatusByRXLVL(rxlvl: number) {
    let peso = 'DOWNdefault';

    if (rxlvl > -70) peso = 'OK';
    if (rxlvl <= -70 && rxlvl >= -80) peso = 'ALERT';
    if (rxlvl < -80) peso = 'ALARM';

    return peso
}


export async function getFinalStatusByStatitics(allFinalStatiticsItems: any) {
    const allFinalStatusItems = ref<any>({})

    Object.entries(allFinalStatiticsItems).forEach(([ip, item]: any, index: number) => {
        const statusItem = getStatusByStatitics(item.latencia, item.snrv, item.snrh, item.rxlvl, item.txlvl);
        allFinalStatusItems.value[ip] = {
            status: statusItem,
            fecha: item.fecha,
            latencia: item.latenciaValue ?? 0,
            snrv: item.snrvValue ?? 0,
            snrh: item.snrhValue ?? 0,
            rxlvl: item.rxlvlValue ?? 0,
            txlvl: item.txlvlValue ?? 0,
            througtput: item.througtput ?? 0,
            temperatura: item.temperatura ?? 0,
            uptime: item.uptime ?? 0,
            perdida: item.perdida ?? 0,
            voltaje: item.voltaje ?? 0,
            costo: item.costo ?? 0,
            gps: item.gps ?? `[0,0,0]`,
        }
    });

    return allFinalStatusItems.value
}